// App.jsx
import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from "./components/ScrollToTop.jsx";

import Navbar from './components/Navbar';
import SideMenu from './components/SideMenu';
import SplashPage from './components/SplashPage';
import HeroSection from './components/HeroSection';
import TexasIslamicConference from './components/TexasIslamicConference.tsx';
import Donations from './components/Donations.tsx';
import VisitingBCS from './components/VisitingBCS.tsx';
import Registration from './components/Registration.tsx';
import ProgramDetails from './components/ProgramDetails.tsx';
import Sponsors from './components/Sponsors.tsx';
import MeetTheTeam from './components/MeetTheTeam';
import ContactUs from './components/ContactUs.tsx';

export default function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      <Navbar
        scrolled={scrolled}
        onMenuToggle={() => setMenuOpen(o => !o)}
        onSearchToggle={() => setSearchOpen(o => !o)}
      />

      <SideMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />

      {/* Scroll to top on every route change (and respect #hash anchors) */}
      <ScrollToTop />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <SplashPage searchOpen={searchOpen} />
              <HeroSection />
            </>
          }
        />
        <Route path="/TexasIslamicConference" element={<TexasIslamicConference />} />
        <Route path="/Donations" element={<Donations />} />
        <Route path="/VisitingBCS" element={<VisitingBCS />} />
        <Route path="/Registration" element={<Registration />} />
        <Route path="/ProgramDetails" element={<ProgramDetails />} />
        <Route path="/Sponsors" element={<Sponsors />} />
        <Route path="/MeetTheTeam" element={<MeetTheTeam />} />
        <Route path="/ContactUs" element={<ContactUs />} />
        {/* Fallback to home sections for any unknown route */}
        <Route
          path="*"
          element={
            <>
              <SplashPage searchOpen={searchOpen} />
              <HeroSection />
            </>
          }
        />
      </Routes>
    </div>
  );
}